import { useState } from 'react';
import { Content, useContent } from 'src/contexts/ContentContext';
import { SidePanelProvider } from 'src/contexts/SidePanelContext';
import { ExplorerLayout } from 'src/core/layouts';
import { vars } from 'src/core/themes';
import { Button } from 'src/core/ui';
import { CreateReachProConversationModal } from 'src/modals/CreateReachProConversationModal/CreateReachProConversationModal';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { IconsFill, PlusIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { MainRoute } from '../MainRoute';
import * as styles from './ReachProSupport.css';
import { ReachProSupportChatPanel } from './ReachProSupportChatPanel';
import { ReachProSupportSidePanel } from './ReachProSupportSidePanel';

export function ReachProSupport() {
  const reachProSupportText = useContent(ContentId.SupportCenter);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <LayoutContent
      mainRoute={MainRoute.ReachProSupport}
      routeTitle={reachProSupportText}
    >
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.title}>
            <Content id={ContentId.SupportCenter} />
          </div>
          <Button
            className={styles.createButton}
            onClick={() => setIsCreateModalOpen(true)}
          >
            <PlusIcon size={vars.iconSize.s} fill={IconsFill.currentColor} />
            <Content id={ContentId.New} />
          </Button>
        </div>
        <div className={styles.body}>
          <SidePanelProvider sidePanelId="reachpro-support" initialOpened>
            <ExplorerLayout
              maxPanelPercent={0.25}
              showExpandButton
              leftPanelContent={<ReachProSupportSidePanel />}
              autoHide={false}
              initialSlide={0}
            >
              <div className={styles.chatContentContainer}>
                <ReachProSupportChatPanel />
              </div>
            </ExplorerLayout>
          </SidePanelProvider>
        </div>
      </div>
      <CreateReachProConversationModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
    </LayoutContent>
  );
}
